import { identify, reportError } from '@dash0/sdk-web';
import type { ErrorTracker } from '@libs/logger';

/**
 * Client-side {@link ErrorTracker} backed by the Dash0 web SDK. Unhandled errors
 * and rejections are already auto-captured by the SDK's error instrumentation;
 * this adapter routes *explicit* `captureException` reports, attaches the user
 * identity, and forwards error-level messages. Lower-severity messages are
 * dropped here because `reportError` is specifically for errors.
 */
export const dash0ClientErrorTracker: ErrorTracker = {
  captureException(error, context): void {
    reportError(
      error,
      context
        ? { attributes: { 'exception.context': JSON.stringify(context) } }
        : undefined,
    );
  },
  captureMessage(message, level = 'info'): void {
    if (level === 'error') reportError(message);
  },
  setUser(user): void {
    identify(user.id);
  },
};
